<p-confirmDialog />

<p-toast
    position="bottom-center"
    key="confirm"
    [baseZIndex]="5000">
        <ng-template let-message pTemplate="message">
            <div class="flex flex-column align-items-start" style="flex: 1">
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-comment" style="font-size: 1.5rem"></i>
                    <span class="font-bold text-900">
                        Servidor
                    </span>
                </div>
                <div class="font-medium text-lg my-3 text-900">
                    {{ message.summary }}
                </div>
                <div class="text-sm font-italic">
                  {{ message.detail }}
                </div>
            </div>
        </ng-template>
</p-toast>

<p-panel header="Mensajes con {{selectedDevice.name}}">
  <p-scrollPanel #terminal [style]="{
    height: '300px',
    'border-radius': '6px',
    'border': '1px solid #3f3f46'
    }">
    <div class="formgrid">
      <app-message-item *ngFor="let message of messagesList" [msgData]="message"></app-message-item>
    </div>
    <div *ngIf="awaitingResponse" class="formgrid ml-3">
      <p-messages [(value)]="loadingMessage" [enableService]="false" [closable]="false" />
    </div>
  </p-scrollPanel>

  <p class="text-small text-color-secondary">Comandos frecuentes</p>
  <div class="card flex align-items-center gap-2 flex-wrap mt-2">
    <button pButton label="Abrir" icon="pi pi-lock-open" [rounded]="true" (click)="confirmCommand('Apertura')" [disabled]="sendingMessage"></button>
    <button pButton label="Ubicación" icon="pi pi-map-marker" [rounded]="true" (click)="confirmCommand('Ubicacion')"  [disabled]="sendingMessage"></button>
    <button pButton label="Reiniciar" icon="pi pi-refresh" [rounded]="true" (click)="confirmCommand('Reinicio')"  [disabled]="sendingMessage"></button>
    <p-button (onClick)="menuBle.toggle($event)" severity="info" rounded="true" label="Bluetooth">
      <span class="material-icons text-base">bluetooth</span>
    </p-button>
    <p-button (onClick)="menuWifi.toggle($event)" severity="help" rounded="true" label="WIFI" icon="pi pi-wifi"/>
    <p-menu #menuBle [model]="bleItems" [popup]="true" />
    <p-menu #menuWifi [model]="wifiItems" [popup]="true" />
  </div>
  <p-divider/>
  <div class="mt-2">
    <p-accordion [activeIndex]="0">
      <p-accordionTab>
        <ng-template pTemplate="header">
          <span class="flex align-items-center gap-2 w-full">
            <i class="pi pi-address-book"></i>
            <span class="font-bold white-space-nowrap">
              Seleccionar comando
            </span>
          </span>
        </ng-template>
        <p-dropdown
        [options]="commands"
        [(ngModel)]="selectedCmd"
        optionLabel="name"
        placeholder="Seleccionar comando"/>
        <button pButton class="p-button-info ml-3" label="Enviar" icon="pi pi-send" (click)="sendCommand(selectedCmd)" [loading]="sendingMessage"></button>
      </p-accordionTab>
      <p-accordionTab>
        <ng-template pTemplate="header">
          <span class="flex align-items-center gap-2 w-full">
            <i class="pi pi-pen-to-square"></i>
            <span class="font-bold white-space-nowrap">
              Personalizar comando
            </span>
          </span>
        </ng-template>

        <input type="text" pInputText [(ngModel)]="customcmd" placeholder=">COMANDO<"/>
        <button pButton class="p-button-info ml-3" label="Enviar" icon="pi pi-send" (click)="sendCommand(customcmd)" [loading]="sendingMessage"></button>
      </p-accordionTab>
  </p-accordion>
  </div>
</p-panel>

<p-dialog header="{{modalTitle}}"[modal]="true" [(visible)]="tokenDetectado" [style]="{ width: '25rem' }" class="text-center">
  <span class="p-text-secondary block mb-5">Use este código para desbloquear el equipo.</span>
  <div class="flex align-items-center mb-3">
      <label for="username" class="text-xl">
        <span><i class="pi pi-lock"></i> {{bleToken}}</span>
      </label>
  </div>
  <div class="flex justify-content-end gap-2">
      <p-button label="OK" (onClick)="tokenDetectado = false" />
  </div>
</p-dialog>
